import React, {useState} from 'react';  
import { Avatar, Button, CssBaseline, TextField, Box, Grid, Typography, Paper } from '@mui/material';
import { useForm, Controller } from "react-hook-form";
import { resetPassword, sendPasswordResetOTP, validateForgotPasswordOTP } from 'core/services/auth';
import { useNavigate, Link } from "react-router-dom";
import { useSnackbar } from 'notistack';

export default function PasswordReset() {
  const defaultValues = {
    mobile: '',
    otp: '',
    newPassword: '',
    confirmPassword: '',
  };
  /* Hooks */
  const { enqueueSnackbar } = useSnackbar();
  const navigate = useNavigate();
  const { handleSubmit, control, formState: { errors }, reset, watch } = useForm({ defaultValues });
  const [isOTPRequested, setIsOTPRequested] = useState(false);
  const [isOTPVerified, setIsOTPVerified] = useState(false);

  function removeEmpty(obj) {
    for (var propName in obj) {
      if (obj[propName] === null || obj[propName] === undefined || obj[propName] === '') {
        delete obj[propName];
      }
    }
    return obj
  }

  
  const requestOTP = (data) => {
    sendPasswordResetOTP(removeEmpty(data)).then(({ response, error }) => {
      if(response){
        setIsOTPRequested(true);
      } else {
        enqueueSnackbar((response?.message || error), {variant: 'error'});
      }
    });
  };

  const passwordReset = (data) => {
    delete data['confirmNewPassword'];
    delete data['otp'];
    resetPassword(removeEmpty(data)).then(({ response, error }) => {
      if(response){
        resetForm();
        navigate('/signin/');
        enqueueSnackbar((response?.message), {variant: 'success'});
      } else {
        enqueueSnackbar((response?.message || error), {variant: 'error'});
      }
    });
  };

  const validateOTP = (data) => {
    validateForgotPasswordOTP(removeEmpty(data)).then(({ response, error }) => {
      if(response){
        setIsOTPVerified(true);
        // enqueueSnackbar((response?.message), {variant: 'success'});
      } else {
        enqueueSnackbar((response?.message || error), {variant: 'error'});
      }
    });
  };

  const onSubmit = (data) => {
    if(isOTPVerified){
      passwordReset(data);
    } else if(isOTPRequested) {
      validateOTP(data);
    }else{
      requestOTP(data);
    }
  };

  const resetForm = () => {
    setIsOTPRequested(false);
    setIsOTPVerified(false);
    reset({...defaultValues});
  }

  return (
      <Grid container component="main" sx={{ height: '100vh' }} >
        <CssBaseline />
        {/* <Grid
          item
          xs={false}
          sm={4}
          md={8}
          sx={{
            backgroundImage: 'url(/assets/images/login-banner.jpg)',
            backgroundRepeat: 'no-repeat',
            backgroundPosition: 'center',
          }}
        /> */}
        <Grid item xs={12} sm={12} md={12} component={Paper} elevation={6} square alignItems="center" justifyContent="center">
          <Box
            sx={{
              my: 8,
              mx: 4,
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
            }}
          >
            <Avatar
              sx={{ m: 2, bgcolor: 'primary.main', width: 100, height: 40 }}
              variant="square"
              alt="Webookr Logo" 
              src={`${process.env.REACT_APP_PATH}/assets/images/webook_logo_large.png`}
              className='login-logo'
            >
              {/* <img alt="Webookr Logo" style={{ width: '100%', height: 'auto',  }} src={`${process.env.REACT_APP_PATH}/assets/images/webook_logo_large.png`} /> */}
            </Avatar>
            <Typography component="h1" variant="h5">
              Forgotten Password?
            </Typography>
            <Typography  variant="caption">
             Enter your registered mobile number to reset your password
            </Typography>
              <Grid container item xs={10} sm={7} md={5} lg={3} alignItems="center" justifyContent="center" sx={{ margin: "0 auto"}}>
                <Box component="form" noValidate onSubmit={handleSubmit(onSubmit)} sx={{ mt: 1, width: '100%' }}>
                  <Grid  item xs={12} sm={12} md={12} lg={12}>
                    <Controller
                      control={control}
                      name="mobile"
                      id="mobile"
                      autoComplete="mobile"
                      rules={{ required: "Enter your registered mobile number",
                        pattern: {
                          value: /^[0-9]{10}$/i,
                          message: "Enter a valid 10 digit registered mobile number",
                        },
                      }}
                      render={({field }) => (
                        <TextField
                          {...field}
                          margin="normal"
                          fullWidth
                          autoFocus
                          size="small"
                          label="Mobile Number"
                          required
                          error={!!errors.mobile_number}
                          helperText={errors.mobile_number?.message}
                          // onBlur={onMobileNumber}
                          disabled={isOTPRequested}
                        />
                      )}
                    />
                </Grid>
                { isOTPRequested ? (
                  <Grid item xs={12} sm={12} md={12} lg={12}>
                    <Controller
                      control={control}
                      name="otp"
                      id="otp"
                      rules={{ required: "Enter the 4-digit PIN sent to your registered mobile number",
                        pattern: {
                          value: /^[0-9]{4}$/i,
                          message: "Enter a valid 4 digit PIN",
                        },
                      }}
                      render={({field }) => (
                        <TextField
                          {...field}
                          margin="normal"
                          fullWidth
                          autoFocus
                          label="OTP"
                          required
                          size="small"
                          error={!!errors.otp}
                          helperText={errors.otp?.message}
                          disabled={isOTPVerified}
                        />
                      )}
                    />
                  </Grid>
                ) : null}
                { isOTPVerified ? (
                  <>
                    <Grid item xs={12} sm={12} md={12} lg={12} >
                      <Controller
                        control={control}
                        name="newPassword"
                        id="newPassword"
                        rules={{ 
                          required: "Password can not be blank",
                          minLength: {
                            value: 6,
                            message: "Password must be minimum 6 characters"
                          }
                          // pattern: {
                          //   value: /^[0-9A-Za-z]$/i,
                          //   message: "Password can contain only Alphabites and Numbers",
                          // },
                        }}
                        render={({field }) => (
                          <TextField
                            type="password"
                            {...field}
                            margin="normal"
                            fullWidth
                            autoFocus
                            size="small"
                            label="Password"
                            required
                            error={!!errors.newPassword}
                            helperText={errors.newPassword?.message}
                            // onBlur={onMobileNumber}
                          />
                          )}
                          />
                    </Grid>
                    <Grid item xs={12} sm={12} md={12} lg={12} >
                      <Controller
                        control={control}
                        name="confirmNewPassword"
                        id="confirmNewPassword"
                        rules={{ 
                          required: "Password can not be blank",
                          minLength: {
                            value: 6,
                            message: "Password must be minimum 6 characters"
                          },
                          // pattern: {
                          //   value: /^[0-9A-Za-z]$/i,
                          //   message: "Password can contain only Alphabites and Numbers",
                          // },
                          validate: (value) => value === watch('newPassword') || "Password fields don't match"
                        }}
                        render={({field }) => (
                          <TextField
                            type="password"
                            {...field}
                            margin="normal"
                            fullWidth
                            size="small"
                            label="Confirm Password"
                            required
                            error={!!errors.confirmNewPassword}
                            helperText={errors.confirmNewPassword?.message}
                            // onBlur={onMobileNumber}
                          />
                          )}
                          />
                    </Grid>
                  </>
                ) : null}
                <Button
                  type="submit"
                  fullWidth
                  variant="contained"
                  sx={{ mt: 3, mb: 2 }}
                >
                  {isOTPRequested ? 'Verify' : 'Reset Password'}
                </Button>
                <Grid container
                  direction="row"
                  justifyContent="center"
                  alignItems="center"
                > 
                  <Button
                    component={Link}
                    to="/signin/"
                    color="black"
                    variant="contained"
                    sx={{ mt: 3, mb: 2 }}
                  >
                    Back
                  </Button>
                </Grid>
              </Box>
            </Grid>
          </Box>
        </Grid>
      </Grid>
  );
}
